import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IAuthFederationEnableRequestBody, IGetAuthFederationAdminResponse } from '../service/AuthFederationService';

export function putAuthFederationAdminRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'PUT',
    endpoint: 'auth-federation/admin',
    serverWideRequest: false
  };
}

export function callPutAuthFederationAdminRequest(
  body: IAuthFederationEnableRequestBody
): Promise<IGetAuthFederationAdminResponse> {
  return makeJsonRestApiRequest<IAuthFederationEnableRequestBody, IGetAuthFederationAdminResponse>({
    config: putAuthFederationAdminRequestConfig(),
    request: body
  });
}
